import type { AnchorHTMLAttributes, ReactNode } from "react";
import { getLocale } from "~/paraglide/runtime";
import {
  getBlogUrl,
  localizeBlogPath,
  type BlogPageType,
} from "~/lib/blog-url";

interface LocalizedBlogLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string;
  locale?: string;
  children: ReactNode;
}

/** Full-navigation anchor that cannot be de-localized by TanStack's route tree. */
export function LocalizedBlogLink({
  href,
  locale = getLocale(),
  children,
  ...props
}: LocalizedBlogLinkProps) {
  return (
    <a href={localizeBlogPath(href, locale)} {...props}>
      {children}
    </a>
  );
}

interface BlogPostLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  post: {
    locale: string;
    slug: string;
    pageType?: BlogPageType | string;
    countryCode?: string | null;
  };
  children: ReactNode;
}

export function BlogPostLink({ post, children, ...props }: BlogPostLinkProps) {
  return (
    <a
      href={getBlogUrl({
        locale: post.locale,
        pageType: post.pageType ?? "editorial",
        slug: post.slug,
        countryCode: post.countryCode,
      }).path}
      {...props}
    >
      {children}
    </a>
  );
}
